module.exports = __webpack_public_path__ + "img/47400.e25cc6d3.jpg";